import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Chart from 'primevue/chart';
import { onMounted, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BarChart',
    props: {
        xLabels: Array,
        data: {
            type: Array,
            default: () => []
        },
        chartHeight: {
            type: Number,
            default: 300
        }
    },
    setup(__props) {
        const props = __props;
        const chartData = ref();
        const chartOptions = ref();
        onMounted(() => {
            chartData.value = setChartData();
            chartOptions.value = setChartOptions();
        });
        const setChartData = () => {
            let dataset = [];
            props.data.forEach((element) => {
                dataset.push({
                    label: element.label,
                    // backgroundColor: element.color,
                    // borderColor: element.color,
                    data: element.data
                });
            });
            return {
                labels: props.xLabels,
                datasets: dataset
            };
        };
        const setChartOptions = () => {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--p-text-color');
            const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
            const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');
            return {
                maintainAspectRatio: false,
                aspectRatio: 0.8,
                plugins: {
                    legend: {
                        labels: {
                            color: textColor
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: textColorSecondary,
                            font: {
                                weight: 500
                            }
                        },
                        grid: {
                            display: false,
                            drawBorder: false
                        }
                    },
                    y: {
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder,
                            drawBorder: false
                        }
                    }
                }
            };
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Chart), {
                type: "bar",
                data: chartData.value,
                options: chartOptions.value,
                style: _normalizeStyle('height:' + props.chartHeight + 'px')
            }, null, 8, ["data", "options", "style"]));
        };
    }
});
